import sanitizeHTML from "sanitize-html";

export const sanitizeHtmlOptions = {
  allowedTags: [
    "h1",
    "h2",
    "h3",
    "strong",
    "b",
    "span",
    "p",
    "u",
    "a",
    "br",
    "ul",
    "li",
    "ol",
    "i",
    "italic",
    "em",
    "hr",
    "s",
    "blockquote",
  ],
  allowedAttributes: {
    "*": ["style", "href", "data-label", "data-id", "colorLink", "color"],
  },
};

export const sentToOneSanitizeHtmlOptions = {
  allowedTags: ["span", "p", "a", "br"],
  allowedAttributes: {
    "*": ["style", "href", "data-label", "data-id", "colorLink", "color"],
  },
};

export const notesSanitizeHtmlOptions = {
  allowedTags: [...sanitizeHtmlOptions.allowedTags],
  allowedAttributes: {
    "*": [
      ...sanitizeHtmlOptions.allowedAttributes["*"],
      "data-type",
      "data-checked",
    ],
  },
};

export const notesOnContactDetails = {
  allowedTags: ["p", "strong"],
  allowedAttributes: {
    "*": ["style", "href", "data-label", "data-id"],
  },
};

export function sanitizeBerserkerEmail(email: string): string {
  return sanitizeHTML(email, sanitizeHtmlOptions);
}
